import { H1, HStack, Search } from '@montel/montelpro-shared-components-v2';
import { Provider } from 'domain/subscription/interfaces/Subscription';
import { useEffect, useState } from 'react';
import { ProviderItem } from './ProviderItem';
import { EditProviderBlacklist } from './EditProviderBlacklist';
import ProviderBlacklistContextProvider, {
	useProviderBlacklistContext,
} from './ProviderBlacklistContext';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { SUBSCRIPTIONS_GET_PROVIDERS } from 'apiRoutes';

const ProviderBlacklistContent: React.FC = () => {
	const [filteredProviders, setFilteredProviders] = useState<Provider[]>([]);
	const { selectedProvider, requestProviderChange } =
		useProviderBlacklistContext();

	const { data: providers } = useGetOnMount<Provider[]>(
		`${SUBSCRIPTIONS_GET_PROVIDERS}?applicationId=${process.env.REACT_APP_MARKETS_APPLICATION_ID}`,
	);

	useEffect(() => {
		setFilteredProviders(providers || []);
	}, [providers]);

	if (!providers || providers.length === 0) {
		return <H1>No Providers Found</H1>;
	}

	const onSearchChange = (e: any) => {
		const searchTerm = e.target.value.toLowerCase();

		const filtered = providers.filter(
			(provider) =>
				provider.name.toLowerCase().includes(searchTerm) ||
				provider.code.toLowerCase().includes(searchTerm),
		);

		setFilteredProviders(filtered);
	};

	return (
		<>
			<H1>Provider Blacklist</H1>
			<HStack align="center" gap="sm">
				<Search
					placeholder="Search Providers"
					onChange={onSearchChange}
				/>
				{}
			</HStack>
			<HStack gap="lg">
				{filteredProviders.map((provider) => (
					<ProviderItem
						provider={provider}
						key={provider.id}
						onClick={() => requestProviderChange(provider)}
						active={selectedProvider?.id === provider.id}
					/>
				))}
			</HStack>
			{selectedProvider && <EditProviderBlacklist />}
		</>
	);
};

export const ProviderBlacklist: React.FC = () => (
	<ProviderBlacklistContextProvider>
		<ProviderBlacklistContent />
	</ProviderBlacklistContextProvider>
);
